<template>
  <tr>
    <td>{{ name }}</td>
    <td>
      <span class="text-primary cursor--pointer" @click="show">
        <i class="fa fa-info-circle"></i> {{ (inEnglish) ? printArticle.name_en : printArticle.name }}
      </span>
    </td>
    <td class="text-right">
      {{ $filters.formatMoney(printArticle.count * price) }}
    </td>
    <td>
      <span v-if="configuration.file">
        {{ configuration.file.original_name}}
      </span>
      <span v-else>
        <i>{{ $t('configurator.labels.upload_missing') }}</i>
      </span>
    </td>
    <td>
      <span class="text-primary cursor--pointer" @click="remove">
        <i class="fa fa-trash"></i> {{ $t('configurator.buttons.delete') }}
      </span>
    </td>
  </tr>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { addLateDeliverySurcharge } from '@/utils/helper'

const store = useMainStore()
// define props
const props = defineProps({
  configuration: {
    type: Object,
    required: true
  },
  article: {
    type: Object,
    required: true
  },
  printArticles: {
    type: Array,
    default: []
  }
})
// define emits
const emit = defineEmits(['remove', 'show'])
// define computed
const locale = computed(() => store.settings.locale)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const price = computed(() => {
  return (earlyBirdMode.value)
    ? addLateDeliverySurcharge(printArticle.value.exhibitionPrices.price_net, lateDelivery.value)
    : printArticle.value.exhibitionPrices.price_net
})

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const print = computed(() => {
  return props.article.prints.find((print) => {
    return print.id === props.configuration.article_print_id
  })
})

const name = computed(() => {
  return (inEnglish.value) ? print.value.name_en : print.value.name
})

const printArticle = computed(() => {
  return props.printArticles.find((printArticle) => {
    return printArticle.id === props.configuration.article_id
  })
})
// define methods
const remove = () => {
  emit('remove', props.configuration)
}

const show = () => {
  emit('show', printArticle.value)
}
</script>